import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { SITE } from "@/config/site";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Privacidade() {
  const { t } = useLanguage();
  const sections = t("privacy.sections");

  return (
    <div data-testid="privacy-page" className="pt-20">
      <Seo title={t("seo.privacy.title")} description={t("seo.privacy.desc")} />

      <section className="pt-16 lg:pt-20 pb-20 max-w-4xl mx-auto px-6">
        <Reveal>
          <span className="mono-tag text-xs uppercase tracking-[0.22em] text-[#C2A675]">{t("privacy.tag")}</span>
          <h1 className="serif-display text-4xl sm:text-5xl font-light text-white mt-4 mb-4">{t("privacy.title")}</h1>
          <p className="text-xs text-[#A8A6A0] font-light mb-12">{t("privacy.updated")}</p>
        </Reveal>

        <div className="space-y-10">
          {sections.map((sec) => (
            <Reveal key={sec.h} className="border-t border-white/10 pt-6">
              <h2 className="serif-display text-2xl font-light text-white mb-4">{sec.h}</h2>
              {sec.p.map((para, i) => (
                <p key={i} className="text-base text-[#A8A6A0] font-light leading-relaxed mb-4 max-w-3xl">{para}</p>
              ))}
            </Reveal>
          ))}
          <Reveal className="border-t border-white/10 pt-6">
            <p className="text-base text-[#A8A6A0] font-light leading-relaxed">
              <a href={`mailto:${SITE.email}`} className="text-[#E8E6E1] underline underline-offset-4 hover:text-[#C2A675] transition-colors">{SITE.email}</a>
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
